module.exports = __webpack_public_path__ + "img/重庆迎龙湖国家湿地公园@2x.bfc6bef4.png";